import { Box, Typography } from "@material-ui/core";
import ScoringToggleButton from "src/components/Button/ScoringToggleButton";

export default function FigureText({ title, value, isToggle = false, ...props }) {
  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" {...props}>
      <Typography variant="subtitle2" color="textSecondary" style={{ fontWeight: "normal", paddingRight: "0.5rem" }}>
        {title}
      </Typography>
      {isToggle ? <ScoringToggleButton isOn={value} disabled /> : <Typography variant="subtitle2">{value}</Typography>}
    </Box>
  );
}
